"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    sourceFontSize: palette.tsSmall,
    sourceLineHeight: palette.tlSmall,
    sourceFontWeight: palette.twSemi,
    sourceColor: palette.tAccent,
    sourceAppearanceOpacity: 1,
    sourceLabelColor: palette.tLabel,
    hintColor: palette.tLabel,
    hintFontSize: palette.tsNormal,
    hintLineHeight: palette.tlNormal,
    hoverSourceColor: palette.tAccentDark,
    disabledColor: palette.tDisabled,
    disabledSourceAppearanceOpacity: 0.15
  };
}